<template>
    <div class="page-container">
        <div class="top-bg"></div>
        <div class="card-box">
            <div class="invoice-total">
                <div class="total-amount">5667.85</div>
                <div class="total-amount-text"><span>未开票总金额(元)</span> <van-icon color="#D3E1EF" size="22" name="eye-o" /></div>
            </div>
            <div class="amount-types">
                <div class="types-item">
                    <div class="item-price">255</div>
                    <div class="item-text">开票中金额(元)</div>
                </div>
                <div class="types-item">
                    <div class="item-price">75</div>
                    <div class="item-text">已开票金额(元)</div>
                </div>
            </div>
            <div class="btn-line">
                <div class="btn-item">申请开发票</div>
                <div class="btn-item">查看开票记录</div>
            </div>
        </div>
        <div class="card-bottom">
            <!-- <div class="invoice-list">
                <div class="stock-item">
                    <div class="time-status">
                        <span>订单编号：32989108123098</span>
                        <span class="item-status">进货成功</span>
                    </div>
                    <div class="goods-bock">
                        <div class="goods-info-block">
                            <img src="" class="goods-pic">
                            <div class="goods-detail">
                                <div class="goods-name">御粮 春生 53度550mp</div>
                                <div class="caigou-price">采购价：¥288.9/瓶</div>
                            </div>
                        </div>
                        <div class="price-count">
                            <div class="goods-price">¥126.88</div>
                            <div class="goods-count">x12(箱)</div>
                        </div>
                    </div>
                </div>
            </div> -->
            <!-- 温馨提示 -->
            <div class="honey-notice">
                <div class="notice-title">温馨提示</div>
                <div class="notice-content">
                    <p>申请开发票时需注意以下几点</p>
                    <p>1、已经申请开票的金额将不能退货</p>
                    <p>2、若是对公转账账户的开票发票抬头需和转账账户一致</p>
                    <p>3、开票时可选择开的发票类型为“明细”或“类别”(明细：具体的酒类别和数量；类别：仅展示为白酒)</p>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
import { Icon } from 'vant'
export default {
    components:{
        [Icon.name]:Icon
    }
}
</script>
<style lang="scss" scoped>
@mixin flex-between{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.page-container{
    min-height:calc(100vh - 46px);
    background:#fafafa;
    .top-bg{
        height:160px;
        background: linear-gradient(110deg, #3CA7FE 0%, #3088F5 100%);
        box-sizing: border-box;
        padding-top: 30px;
    }
    .card-box{
        width:355px;
        height:267px;
        box-sizing: border-box;
        padding:20px 40px;
        overflow: hidden;
        background: #FFFFFF;
        box-shadow: 0px 8px 24px -5px rgba(211, 225, 239, 0.6);
        @media screen and (max-width: 750px){
            border-radius: 4px;
        }
        position: relative;
        top:-130px;
        left:10px;
        .invoice-total{
            margin-top: 20px;
            text-align: center;
            .total-amount{
                color:#333;
                font-size: 30px;
                font-weight: bold;
                line-height: 35px;
                margin-bottom: 3px;
                font-family: DINAlternate-Bold, DINAlternate;
            }
            .total-amount-text{
                display: flex;
                justify-content: center;
                align-items: center;
                color:#999;
                line-height: 18px;
                font-size: 13px;
                &>span{
                    margin-right: 4px;
                }
            }
        }
        .amount-types{
            margin:30px 0;
            @include flex-between;
            .types-item{
                text-align: center;
                .item-price{
                    margin-bottom: 5px;
                    line-height: 21px;
                    font-size: 18px;
                    font-family: DINAlternate-Bold, DINAlternate;
                    font-weight: bold;
                    color: #333333;
                }
                .item-text{
                    color:#999;
                    line-height: 18px;
                    font-size: 13px;
                }
            }
        }
        .btn-line{
            @include flex-between;
            .btn-item{
                width: 120px;
                height: 36px;
                line-height: 36px;
                background: #FFFFFF;
                border: 1px solid #3088F5;
                font-size: 14px;
                color:#3088f5;
                text-align: center;
                @media screen and (max-width: 750px){
                    border-radius: 6px;
                }
                &:last-child{
                    border: 1px solid #C8C8C8;
                    color:#999;
                }
            }
        }
    }
    .card-bottom{
        position: relative;
        top:-110px;
        .invoice-list{
            padding:10px;
            .stock-item{
                background:#fff;
                margin-top: 10px;
                padding:0 15px;
                @media screen and (max-width: 750px){
                    border-radius: 4px;
                }
                .time-status{
                    height:50px;
                    line-height: 50px;
                    box-sizing: border-box;
                    color:#333;
                    border-bottom:1px solid #f0f0f0;
                    font-size: 16px;
                    @include flex-between;
                    .item-status{
                        font-size: 14px;
                        color:#3088F5;
                    }
                }
                .goods-bock{
                    padding:15px;
                    box-sizing: border-box;
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-start;
                    .goods-info-block{
                        width:220px;
                        display: flex;
                        justify-content: flex-start;
                        .goods-pic{
                            width:60px;
                            height:60px;
                            margin-right: 10px;
                            border-radius: 4px;
                        }
                        .goods-detail{
                            display: flex;
                            flex-direction: column;
                            justify-content: space-between;
                            .goods-name{
                                width:180px;
                                overflow: hidden;
                                text-overflow:ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                -webkit-box-orient: vertical;
                                color:#000;
                                line-height: 20px;
                                font-size: 14px;
                            }
                            .caigou-price{
                                color:#999;
                                line-height: 18px;
                                font-size: 12px;
                            }
                        }
                    }
                    .price-count{
                        width: 80px;
                        text-align: right;
                        .goods-price{
                            color:#333;
                            line-height: 20px;
                            margin-bottom: 10px;
                            font-size: 14px;
                        }
                        .goods-count{
                            color:#3088F5;
                            line-height: 18px;
                            font-size: 12px;
                        }
                    }
                }
            }
        }
        .honey-notice{
            padding:10px;
            margin-top: 20px;
            .notice-title{
                font-size: 14px;
                line-height: 20px;
                color:#3088F5;
                margin-bottom: 10px;
            }
            .notice-content{
                &>p{
                    color:#999;
                    line-height: 18px;
                    font-size: 12px;
                    margin:4px 0;
                }
            }
        }
    }
}
</style>